export default __webpack_public_path__ + "static/media/slot-machine2.c98c6821.png";